let SelectOptions = {};
SelectOptions.gender = [
  { text: 'Male', value: 'm' },
  { text: 'Female', value: 'f' },
  { text: 'Unspecified', value: 'u' },
]

SelectOptions.civil_status = [
  { text: 'Single', value: 'single' },
  { text: 'Married', value: 'married' },
]

SelectOptions.phone_type = [
  { text: 'Mobile', value: 'MobilePhone' },
  { text: 'Landline', value: 'LandlinePhone' },
]

SelectOptions.id_type = [
  { text: '', value: '' },
  { text: 'Passport', value: 'PP' },
  { text: 'Driver\'s License', value: 'DL' },
  { text: 'Social Security System', value: 'SSS' },
  { text: 'Tax Identification Number', value: 'TIN' },
  { text: 'Philhealth', value: 'PHILHEALTH' },
  { text: 'Unified Multi-Purpose ID Number', value: 'UMID' },
  { text: 'Postal ID Number', value: 'POSTALID' },
  { text: 'NBI Number', value: 'NBI' },
]

SelectOptions.document_type = [
  { text: '2 Valid IDs', value: 'Document::IdProof' },
  { text: 'Proof of Billing', value: 'Document::BillingProof' },
  { text: 'DTI Certificate', value: 'Document::DtiCertificate' },
  { text: 'BIR Certificate', value: 'Document::BirCertificate' },
  { text: 'SEC Certificate', value: 'Document::SecCertificate' },
  { text: 'Bank Statement', value: 'Document::BankStatement' },
  { text: 'ITR', value: 'Document::Itr' },
]

SelectOptions.id_proof_kind = [
  { text: 'Passport', value: 'Passport' },
  { text: 'SSS ID', value: 'SSS' },
  { text: 'Postal ID', value: 'PostalID' },
  { text: 'UMID', value: 'UMID' },
  { text: 'Driver’s License', value: 'DriverLicense' },
  { text: 'Philhealth', value: 'Philhealth' },
  { text: 'TIN', value: 'TIN' }
];

SelectOptions.billing_proof_kind = [
  { text: 'Meralco', value: 'Meralco' },
  { text: 'PLDT/Smart', value: 'PLDT/Smart' },
  { text: 'Globe', value: 'Globe' },
  { text: 'Utility Bill', value: 'UtilityBill' },
  { text: 'Water Bill', value: 'WaterBill' },
  { text: 'Lease Contract', value: 'LeaseContract' },
]

SelectOptions.loan_plan_frequency = [
  { text: 'Every week', value: 7 },
  { text: 'Every 2 weeks', value: 14 },
  { text: 'Every 3 weeks', value: 21 },
  { text: 'Every 4 weeks', value: 28 },
  { text: 'Custom', value: 'custom' },
]

SelectOptions.repayment_types = [
  { text: 'Discouting', value: 'discounting' },
  { text: 'Interest rate on top', value: 'interest_rate_on_top' }
]

SelectOptions.repayment_types = [
  { text: 'unscheduled', value: 'unscheduled' },
  { text: 'late_fee', value: 'late_fee' },
  { text: 'credit_line_extension', value: 'credit_line_extension' },
  { text: 'promise_to_pay', value: 'promise_to_pay' },
]

SelectOptions.waived_amount_types = [
  { text: 'Fee', value: 'fee_waived' },
  { text: 'Principal and/or Interest', value: 'principal_interest_waived' },
]

SelectOptions.note_next_actions = [
  {
    text: "Phone Call",
    value: "call"
  },
  {
    text: "Site Visit",
    value: "visit"
  },
  {
    text: "Book Courier",
    vlaue: "book_courier"
  },
  {
    text: "Underwriting Session",
    value: "underwriting"
  },
  {
    text: "Promise to Pay",
    value: "promise_to_pay"
  },
  {
    text: "Meeting Schedule",
    value: "meeting_schedule"
  }
]

SelectOptions.last_duration = [
  { text: 'Hours', value: 'hours' },
  { text: 'Weeks', value: 'weeks' },
  { text: 'Days', value: 'days' }
]

SelectOptions.custom_field_types = [
  { text: 'Free Text', value: 'TextCustomField' },
  { text: 'Dropdown', value: 'DropdownCustomField' },
  { text: 'Multiple Dropdown', value: 'MultipleDropdownCustomField' },
  { text: 'Currency', value: 'CurrencyCustomField' },
  { text: 'Number', value: 'NumberCustomField' },
  { text: 'Percentage', value: 'PercentageCustomField' },
  { text: 'Date', value: 'DateCustomField' },
  { text: 'Landline Phone', value: 'LandlinePhoneNumberCustomField' },
  { text: 'Mobile Phone', value: 'MobilePhoneNumberCustomField' },
  { text: 'Contact Number', value: 'ContactNumberCustomField' },
  { text: 'Json', value: 'JsonCustomField' }
]

SelectOptions.custom_field_object_types = [
  { text: 'Lead', value: 'lead' },
  { text: 'Loan Application', value: 'loan_application' }
]

SelectOptions.data_point_group_object_types = [
  { text: 'Leads', value: 'LeadDataPointGroup'},
  { text: 'Business Connections', value: 'BusinessConnectionDataPointGroup'}
]

SelectOptions.purchase_order_types = [
  { text: 'Purchase Order', value: 'purchase_order' },
  { text: 'Invoice', value: 'invoice' }
];

SelectOptions.purchase_order_payment_methods = [
  { text: 'Cash', value: 'cash' },
  { text: 'Check', value: 'check' },
  { text: 'Bank Transfer', value: 'bank_transfer' },
];

SelectOptions.bucket_order_by_options = [
  { text: 'Last Note Logged ASC', value: 'leads.last_note_logged ASC'},
  { text: 'Last Note Logged DESC', value: 'leads.last_note_logged DESC NULLS LAST'},
  { text: 'Created At ASC', value: 'leads.created_at ASC'},
  { text: 'Created At DESC', value: 'leads.created_at DESC NULLS LAST'}
];

SelectOptions.attachment_sort_types = [
  { text: 'Date: Oldest First', value: 'date_ascending' },
  { text: 'Date: Newest First', value: 'date_descending' },
  { text: 'Attachment Type', value: 'attachment_type' },
]

// Delete this and modify the one above if Attachments tab
// is to be removed when Requirements Hub gets shipped.
SelectOptions.hub_attachment_sort_types = [
  { text: 'Oldest', value: 'date_ascending' },
  { text: 'Newest', value: 'date_descending' },
  { text: 'Attachment Type', value: 'attachment_type' },
]

SelectOptions.bank_account_types = [
  { text: 'Checking', value: 'checking' },
  { text: 'Savings', value: 'savings' }
];

SelectOptions.bank_account_kind = [
  { text: '', value: '' },
  { text: 'Personal', value: 'Personal' },
  { text: 'Corporate', value: 'Corporate' }
];

SelectOptions.schedule_frequency = [
  { text: "Daily", value: "daily"},
  { text: "Weekly", value: "weekly"},
  { text: "Monthly", value: "monthly"},
  { text: "Twice Monthly", value: "twice_monthly"},
  { text: "Yearly", value: "yearly"}
];

SelectOptions.receivable_types = [
  { text: 'Discounting', value: 'discounting' },
  { text: 'Purchase Order Finance', value: 'interest_rate_on_top' }
]

SelectOptions.interest_rate_types = [
  { text: 'One off', value: 'one_off' },
  { text: 'Per day', value: 'per_day' },
  { text: 'Per week', value: 'per_week' },
  { text: 'Per month', value: 'per_month' }
]

SelectOptions.qualification_status = [
  { text: 'Qualified', value: 'qualified'},
  { text: 'Unqualified', value: 'unqualified'},
  { text: 'Unknown', value: 'unknown'}
]

SelectOptions.business_type = [
  { text: 'Select Business Type', value: '' },
  { text: 'Sole Proprietor', value: 'single' },
  { text: 'Partnership', value: 'partnership' },
  { text: 'Corporation', value: 'corporation' }
]

SelectOptions.company_user_roles = [
  { text: 'Select a Role', value: '' },
  { text: 'President', value: 'president' },
  { text: 'VP', value: 'vp' },
  { text: 'Board Member', value: 'board_member' },
  { text: 'Partner', value: "partner" },
  { text: 'Managing Partner', value: "managing_partner" },
  { text: 'Officer', value: "officer" },
  { text: 'Manager', value: "manager" },
  { text: 'Line Staff', value: "line" },
]

SelectOptions.company_number_of_employees = [
  { text: 'Select a Value', value: '' },
  { text: '0 - 10', value: '0_10' },
  { text: '10 - 25', value: '10_25' },
  { text: '25 - 50', value: '25_50' },
  { text: '50 - 100', value: '50_100' },
  { text: '100+', value: '100plus' },
]

SelectOptions.company_monthly_sales = [
  { text: 'Please Select', value: ''},
  { text: 'Less than ₱100,000', value: '<100K'},
  { text: '₱100k - ₱500k', value: '100_500'},
  { text: '₱500k - ₱2,5m', value: '500k_2.5m'},
  { text: '₱2.5m - ₱10m', value: '2.5m_10m'},
  { text: '₱10m - ₱50₱', value: '10m_50m'},
  { text: '₱50m+', value: '50m_plus'},
]

SelectOptions.industries = [
  ['None Selected', [{text: 'None Selected', value: ''}]],
  ['Distribution',
    [
      {text: 'Automobile & other machinery', value: 'distribution_automobile-other-machinery'},
      {text: 'Cosmetics and beauty supplies', value: 'distribution_cosmetics-and-beauty-supplies'},
      {text: 'Electronics', value: 'distribution_electronics'},
      {text: 'Fashion, apparel, and accessories', value: 'distribution_fashion-apparel-and-accessories'},
      {text: 'Food and beverage', value: 'distribution_food-and-beverage'},
      {text: 'Furniture', value: 'distribution_furniture'},
      {text: 'Grocery and Convenience store - regular', value: 'distribution_grocery-and-convenience-store-regular'},
      {text: 'Health and medical supplies', value: 'distribution_health-and-medical-supplies'},
      {text: 'Office supplies', value: 'distribution_office-supplies'},
    ]
  ],
  ['Manufacturing',
    [
      {text: 'Automobile & other machinery', value: 'manufacturing_automobile-other-machinery'},
      {text: 'Cosmetics and beauty supplies', value: 'manufacturing_cosmetics-and-beauty-supplies'},
      {text: 'Electronics', value: 'manufacturing_electronics'},
      {text: 'Farming & agriculture', value: 'manufacturing_farming-agriculture'},
      {text: 'Fashion, apparel, and accessories', value: 'manufacturing_fashion-apparel-and-accessories'},
      {text: 'Food and beverage', value: 'manufacturing_food-and-beverage'},
      {text: 'Furniture', value: 'manufacturing_furniture'},
      {text: 'Health and medical supplies', value: 'manufacturing_health-and-medical-supplies'},
      {text: 'Office supplies', value: 'manufacturing_office-supplies'},
      {text: 'Raw material suppliers (plastics, metals, etc.)', value: 'manufacturing_raw-material-suppliers-plastics-metals-etc'},
    ]
  ],
  ['Retail',
    [
      {text: 'Automobile & other machinery', value: 'retail_automobile-other-machinery'},
      {text: 'Cosmetics and beauty supplies', value: 'retail_cosmetics-and-beauty-supplies'},
      {text: 'Electronics', value: 'retail_electronics'},
      {text: 'Fashion, apparel, and accessories', value: 'retail_fashion-apparel-and-accessories'},
      {text: 'Food and beverage', value: 'retail_food-and-beverage'},
      {text: 'Furniture', value: 'retail_furniture'},
      {text: 'Grocery and Convenience store - regular', value: 'retail_grocery-and-convenience-store-regular'},
      {text: 'Grocery and Convenience store - franchise', value: 'retail_grocery-and-convenience-store-franchise'},
      {text: 'Health and medical supplies', value: 'retail_health-and-medical-supplies'},
      {text: 'Multi-Level Marketing', value: 'retail_multi-level-marketing'},
      {text: 'Office supplies', value: 'retail_office-supplies'},
    ]
  ],
  ['Services',
    [
      {text: 'Accounting', value: 'services_accounting'},
      {text: 'Banking', value: 'services_banking'},
      {text: 'Business consulting', value: 'services_business-consulting'},
      {text: 'Call center', value: 'services_call-center'},
      {text: 'Cleaning', value: 'services_cleaning'},
      {text: 'Construction - manpower', value: 'services_construction-manpower'},
      {text: 'Construction - services', value: 'services_construction-services'},
      {text: 'Education', value: 'services_education'},
      {text: 'Entertainment', value: 'services_entertainment'},
      {text: 'Gambling', value: 'services_gambling'},
      {text: 'Hospitality – regular', value: 'services_hospitality-regular'},
      {text: 'Hospitality – franchise', value: 'services_hospitality-franchise'},
      {text: 'Hospitals & healthcare', value: 'services_hospitals-healthcare'},
      {text: 'Insurance', value: 'services_insurance'},
      {text: 'IT services', value: 'services_it-services'},
      {text: 'Legal', value: 'services_legal'},
      {text: 'Logistics & transportation', value: 'services_logistics-transportation'},
      {text: 'Media & advertising', value: 'services_media-advertising'},
      {text: 'Multi-level Marketing', value: 'services_multi-level-marketing'},
      {text: 'Non-profit', value: 'services_non-profit'},
      {text: 'Real Estate', value: 'services_real-estate'},
      {text: 'Research & development', value: 'services_research-development'},
      {text: 'Restaurants & bars – regular', value: 'services_restaurants-bars-regular'},
      {text: 'Restaurant & bars – franchise', value: 'services_restaurant-bars-franchise'},
      {text: 'Security', value: 'services_security'},
      {text: 'Spa, massage & wellness', value: 'services_spa-massage-wellness'},
      {text: 'Travel agencies', value: 'services_travel-agencies'},
      {text: 'Utility providers', value: 'services_utility-providers'},
    ]
  ]
]

SelectOptions.company_location = [
  { text: 'Please Select', value: ''},
  { text: 'Caloocan', value: 'caloocan'},
  { text: 'Las Piñas', value: 'las-pinas'},
  { text: 'Makati', value: 'makati'},
  { text: 'Malabon', value: 'malabon'},
  { text: 'Mandaluyong', value: 'mandaluyong'},
  { text: 'Manila', value: 'manila'},
  { text: 'Marikina', value: 'marikina'},
  { text: 'Muntinlupa', value: 'muntinlupa'},
  { text: 'Navotas', value: 'navotas'},
  { text: 'Parañaque', value: 'paranaque'},
  { text: 'Pasay', value: 'pasay'},
  { text: 'Pasig', value: 'pasig'},
  { text: 'Pateros', value: 'pateros'},
  { text: 'Quezon City', value: 'quezon-city'},
  { text: 'San Juan', value: 'san-juan'},
  { text: 'Taguig', value: 'taguig'},
  { text: 'Valenzuela', value: 'valenzuela'},
  { text: 'Outside Metro Manila', value: 'outside-metro-manila'},
]

SelectOptions.sales_channel = [
  { text: 'Select Sales Channel', value: '' },
  { text: 'Online', value: 'online' },
  { text: 'Offline', value: 'offline' }
]

SelectOptions.loan_type = [
  { text: 'Select Loan Type', value: '' },
  { text: 'UBL', value: 'ubl' },
  { text: 'ID', value: 'id' },
  { text: 'POF', value: 'pof' }
]

SelectOptions.delinquency_statuses = [
  {text: "Bounced", value: "bounced"},
  {text: "Hold Check", value: "hold_check"},
  {text: "Extension", value: "extension"}
]

SelectOptions.delinquency_reasons = [
  {text: "Collection Problems", value: "collection_problems"},
  {text: "Financial Difficulty", value: "financial_difficulty"},
  {text: "Illness", value: "illness"},
  {text: "Calamity", value: "calamity"},
  {text: "Fraud Related Issues", value: "fraud_related_issues"},
  {text: "Deceased", value: "deceased"},
  {text: "Unknown", value: "unknown"}
]

export default SelectOptions;



// WEBPACK FOOTER //
// ./src/utils/SelectOptions.js